import axiosInstance from './axios';

export const inquiryService = {
  list: async (params = {}) => {
    const response = await axiosInstance.get('/b2b-inquiries', { params });
    return response.data;
  },

  statistics: async () => {
    const response = await axiosInstance.get('/b2b-inquiries/statistics');
    return response.data;
  },

  show: async (id) => {
    const response = await axiosInstance.get(`/b2b-inquiries/${id}`);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await axiosInstance.put(`/b2b-inquiries/${id}`, payload);
    return response.data;
  },

  remove: async (id) => {
    const response = await axiosInstance.delete(`/b2b-inquiries/${id}`);
    return response.data;
  },
};
